import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { find, isEmpty, reduce } from 'lodash-es';
import SearchTypeahead from './SearchTypeahead';

const renderMenuItem = item => (
  <div className="ticker-found-item">
    <span className="company-name">{item.name}</span>
    <span>{item.ticker}</span>
  </div>
);

const TickersSearch = ({ tickers, assetName = 'companies', onSelected }) => {
  const searchRef = useRef(null);
  const searchTypeaheadRef = () =>
    !!searchRef.current && searchRef.current.typeaheadInstance();
  const handleSelectTickers = (selectedTicker) => {
    if (!selectedTicker) return;
    onSelected(selectedTicker);
    if (searchRef.current) {
      searchTypeaheadRef().clear();
      searchTypeaheadRef().setState({ text: searchRef.current.state.query });
      searchTypeaheadRef().focus();
    }
  };
  const handleTickerSelected = (selectedTicker) => {
    const selectedTickers = tickers || [];
    const itemSelected = !!find(selectedTickers, ticker =>
      ticker.ticker.toString() === selectedTicker.ticker.toString());
    const showReplaceButton = false;
    return { itemSelected, showReplaceButton };
  };
  return (
    <div className="tickers-search">
      <SearchTypeahead
        autoFocus={false}
        searchAsset={assetName}
        className="w-100"
        itemSelected={handleTickerSelected}
        maxHeight="550px"
        placeholder="Search for Ticker"
        ref={searchRef}
        clearButton
        renderMenuItem={renderMenuItem}
        decorateItems={data => reduce(data, (acc, report) => {
          if (!isEmpty(report.ticker)) {
            return [...acc, { ...report, value: report.ticker.trim() }];
          }
          return acc;
        }, [])}
        onChange={items => handleSelectTickers(items[0])}
      />
    </div>

  );
};

TickersSearch.propTypes = {
  tickers: PropTypes.array,
  assetName: PropTypes.string,
  onSelected: PropTypes.func,
};

export default TickersSearch;
